import {AutoInitializing, UnLitElement} from "../../common/elements";
import {customElement, query} from "lit/decorators.js";
import {ManagingResources} from "../../common/lifetime";
import {ScrollableBar} from "./scrollableBar";
import {Dictionary} from "./dictionary";
import {html, type PropertyValues, type TemplateResult} from "lit";

@customElement("eop-content-navigation")
export class EopContentNavigation extends ManagingResources(AutoInitializing(UnLitElement)) {

    @query(".content-navigation-tabs")
    private contentNavigationTabs: HTMLElement;
    private tabs: NodeListOf<HTMLElement>;
    private scrollBar: ScrollableBar;
    protected dictionary: Dictionary;

    public connectedCallback(): void {
        super.connectedCallback();
        this.dictionary = Dictionary.of(this);
        this.tabs = this.querySelectorAll(".content-navigation-item");
        this.tabs.forEach(item => item.classList.add("scrollable-item"));
    }

    public render(): TemplateResult {
        return html`
            <div class="content-navigation-bar">
                <nav class="content-navigation-tabs" aria-label=${this.dictionary.translate("MSG_CONTENT_NAVIGATION")}>
                    <ul class="content-navigation-items horizontally-scrollable-area">
                        ${this.renderItems()}
                    </ul>
                </nav>
            </div>
        `;
    }

    private renderItems(): TemplateResult[] {
        return Array.from(this.tabs).map((item) => {
            return html`${item}`;
        });
    }

    protected firstUpdated(_changedProperties: PropertyValues): void {
        super.firstUpdated(_changedProperties);
        this.scrollBar = new ScrollableBar(this.contentNavigationTabs, this.dictionary);
        this.scrollBar.scrollToItem(this.activeTabIndex());
    }

    public disconnectedCallback(): void {
        this.scrollBar.disconnect();
        super.disconnectedCallback();
    }

    private activeTabIndex(): number {
        for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].querySelector(".active")) {
                return i;
            }
        }
        return 0;
    }
}
